import React, { useState } from 'react'
import './styles.scss'
import { config } from './config'

interface Props {
  range: [number, number]
  unit?: string
  step?: number
  submit: (a: string) => void
  start?: number
}

export const Slider = ({ range, unit, step = 1, submit, start }: Props) => {
  if (start==null) start = range[0] + (range[1] - range[0]) / 2

  const [value, setValue] = useState<number>(start)
  const [formState, setFormState] = useState<'loaded' | 'send' | 'error'>(
    'loaded'
  )
  const getPercent = (val: number, ran: [number, number]) => {
    return ((val - ran[0]) * 100) / (ran[1] - ran[0])
  }
  const formatValue = (val: number) => {
    return val + (unit ? unit : '')
  }
  return (
    <div className='Slider'>
      <form
        onSubmit={(e: React.FormEvent) => {
          e.preventDefault()
          if (!value && value !== 0) {
            setFormState('error')
            return
          }
          submit(value.toString())
        }}
      >
        <div className='wrapper'>
          <div className='outputwrapper'>
            <output
              style={{
                left: getPercent(value, range) + '%'
              }}
            >
              {formatValue(value)}
            </output>
          </div>
          <input
            type='range'
            min={range[0]}
            max={range[1]}
            value={value}
            step={step}
            onChange={e => {
              setValue(+e.target.value)
            }}
          />
          <label className='left'>{formatValue(range[0])}</label>
          <label className='right'>{formatValue(range[1])}</label>
        </div>
        <div className='actionrow'>
          <button type='submit'>Antworten</button>
        </div>
      </form>
    </div>
  )
}
